<mat-tab-group>
  <ng-container *ngFor="let report of reports">
    <mat-tab label="{{ report.name }}">
      <app-report-embed [name]="report.name"></app-report-embed>
    </mat-tab>
  </ng-container>
</mat-tab-group>
